import React from "react"
import PropTypes from "prop-types"
import { Radio, Typography } from "antd"
import styles from "./BookingForm.module.css"

const { Text } = Typography

const TimeDurationSelector = ({ options, valueKey = "key", displayKey = "value", selectedValue, onChange, disabled }) => {
  return (
    <div className={styles.optionSelectorWrapper}>
      <Radio.Group
        className={styles.radioGroup}
        optionType="button"
        value={selectedValue}
        onChange={(e) => {
          const selected = (options || []).find((opt) => opt[valueKey] === e.target.value)
          if (selected) onChange(selected)
        }}
      >
        {options?.map((option) => (
          <Radio.Button
            key={option[valueKey]}
            value={option[valueKey]}
            className={selectedValue === option[valueKey] ? `${styles.radioButton} ${styles.radioButtonChecked}` : styles.radioButton}
            disabled={disabled}
          >
            {option[displayKey]}
          </Radio.Button>
        ))}
      </Radio.Group>
      {options?.length === 0 && <Text type="secondary">No slots available</Text>}
    </div>
  )
}

TimeDurationSelector.propTypes = {
  options: PropTypes.array.isRequired,
  valueKey: PropTypes.string,
  displayKey: PropTypes.string,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
}

export default React.memo(TimeDurationSelector)
